import reducer from './reducers/index';
import { routes } from '../routes';
import * as publicPageActions from './actions'
import * as publicPageOperation from './operations'
import * as publicPageSelectors from './selectors'

export {
    publicPageActions,
    publicPageOperation,
    publicPageSelectors,
}

export default {
    routes,
    reducer
}
